var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "请输入检查结果",
        okText: "确认",
        cancelText: "下载",
        width: "800px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { cancel: _vm.handleOk },
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [
            _vm._v(" 下载 "),
          ]),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
            [_vm._v(" 确认 ")]
          ),
        ],
        1
      ),
      _c("a", {
        ref: "downbtn",
        staticStyle: { display: "none" },
        attrs: {
          href:
            _vm.baseApi + "mvc/common-file/downloadById?id=" + this.param.picId,
        },
      }),
      _c("img", {
        staticStyle: { "max-width": "100%", "max-height": "100%" },
        attrs: {
          src:
            _vm.baseApi + "mvc/common-file/PreviewById?id=" + this.param.picId,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }